export enum StepIdsEnum {
	TOUR_START = 'tour-start',
	COPY_MOVE = 'copy-move',
	COMPARE = 'compare',
	ADD_TO_CART = 'add-to-cart',
	NEW_GROUP = 'new-group',
	GROUP = 'group',
	SEARCH_FROM_PROJECTS = 'search-from-projects',
	EDIT_PRODUCT = 'edit-product',
	COMMENT = 'comment',
	ORDERS_RETURNS = 'orders-returns',
	COMMUNICATION = 'communication',
	PORTFOLIO = 'portfolio',
	TOUR_END = 'tour-end'
}
